import styled, { css } from 'styled-components'
import { zindex, colors } from '@chegg-ui/theme'

const fixedOverlay = css`
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: ${zindex.modal};
`

export const LoaderOverlay = styled.div`
  ${fixedOverlay};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.45);
`

export const LoaderContainer = styled.div`
  background-color: ${colors.greyXlight};
  border-radius: 16px;
  border: 10px solid rgba(200, 200, 200, 0.5);
`

export const OneAuthWrapper = styled.div`
  /* ${fixedOverlay}; */
`

export const Loading = styled.div`
  background: white;
  left: 50%;
  top: 160px;
  width: 122px;
  height: 45px;
  margin-left: -61px;
  position: absolute;
  border-radius: 50px;
  text-align: center;
  vertical-align: middle;
`
